import { render, staticRenderFns } from "./detalhesTitulo.vue?vue&type=template&id=2e979f92&scoped=true"
import script from "./detalhesTitulo.vue?vue&type=script&lang=js"
export * from "./detalhesTitulo.vue?vue&type=script&lang=js"
import style0 from "./detalhesTitulo.vue?vue&type=style&index=0&id=2e979f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e979f92",
  null
  
)

export default component.exports